import "./BlogPage.scss";
import BlogBtn from "../../assets/Button/ButtonDetails/ButtonDetails";
import strawberryImg from "../../image/blog/strawberries.jpg";
import blueberryImg from "../../icons/blog/blueberry.jpg";
import cucumberImg from "../../icons/blog/cucumbers.jpg";
import React, { useState } from "react";
import { Link } from "react-router-dom";

const ARTICLES = [
    {
        id: 1,
        title: "Добрива для полуниці",
        excerpt: "Солодку полуницю або, як її ще називають, садову суницю полюбляють і дорослі, і діти, тому охоче саджають та вирощують ягоди на присадибних ділянках та приватних фермах...",
        image: strawberryImg,
        date: "06 чер",
        tag: "Новинка!",
        to: "/strawberries",
    },
    {
        id: 2,
        title: "Секрети підживлення лохини",
        excerpt: "Солодку полуницю або, як її ще називають, садову суницю полюбляють і дорослі, і діти, тому охоче саджають та вирощують ягоди на присадибних ділянках та приватних фермах...",
        image: blueberryImg,
        date: "09 чер",
        tag: "Гайд",
        to: "/blueberry",
    },
    {
        id: 3,
        title: "Як підживити огірки без помилок",
        excerpt: "Солодку полуницю або, як її ще називають, садову суницю полюбляють і дорослі, і діти, тому охоче саджають та вирощують ягоди на присадибних ділянках та приватних фермах...",
        image: cucumberImg,
        date: "11 чер",
        tag: "Поради",
        to: "/cucumber",
    },
];


function ArticlesSection() {
    const [visible, setVisible] = useState(3); // скільки карток показуємо
    const showMore = () => setVisible((v) => Math.min(v + 3, ARTICLES.length));

    return (
        <section className="blog__articles">
            <div className="blog__articles__head">
                <h2 className="blog__articles__head--text">Корисні статті:</h2>
                <p>Добірка свіжих гайдів, порад і коротких схем підживлення.</p>
            </div>

            <div className="blog__articles__grid">
                {ARTICLES.slice(0, visible).map((a) => (
                    <article className="blog__card" key={a.id}>
                        <Link to={a.to} className="blog__card__link" aria-label={a.title}>
                            <div className="blog__card__media">
                                <img src={a.image} alt={a.title} loading="lazy" />
                                <span className="blog__card__date">{a.date}</span>
                                {a.tag && <span className="blog__card__badge">{a.tag}</span>}
                                <div className="blog__card__scrim" />
                            </div>

                            <div className="blog__card__content">
                                <h3 className="blog__card__title">{a.title}</h3>
                                <p className="blog__card__excerpt">{a.excerpt}</p>
                                <div className="blog__card__cta">
                                    <span>Читати</span>
                                    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
                                        <path d="M13 5l7 7-7 7M5 12h14" fill="none" stroke="currentColor" strokeWidth="2" />
                                    </svg>
                                </div>
                            </div>
                        </Link>
                    </article>
                ))}
            </div>

            {visible < ARTICLES.length && (
                <button className="blog__articles__more" onClick={showMore}>
                    Показати ще
                </button>
            )}
        </section>
    );
}

export default function BlogPage() {
    return (
        <div className="blog__wrapper">
            <div className="blog__wrapper__header">
                <div className="blog__wrapper__header__photo">
                    <p className="blog__wrapper__header__photo--first-text">
                        НАСОЛОДЖУЙТЕСЬ КРАСОЮ ВАШОГО ВРОЖАЮ РАЗОМ З НАМИ!
                    </p>
                    <p className="blog__wrapper__header__photo--second-text">
                        Завітайте до нашого блогу про догляд за садом та городом!
                    </p>
                    <Link to="blog" className="blog__wrapper__header__photo--button">
                        <BlogBtn />
                    </Link>
                </div>
            </div>
            <ArticlesSection />
        </div>
    );
}
